import { methods } from "../enums/index.js";
import { apiAction } from "./index.js";

export const subscriptionDataPost = data => ["/subscription", methods.POST, data];
export const subscriptionDataPut = data => [`/subscription/${data._id}`, methods.PUT, data];
export const subscriptionDelete = id => [`/subscription/${id}`, methods.DELETE];
export const subscriptionOneGet = id => apiAction(`/subscription/one/${id}`);
export const subscriptionFilterGet = (search = "", page = 1, limit = 100, sort = "", filter = "") => apiAction(`/subscription/filter?search=${search}&page=${page}&limit=${limit}&sort=${sort}&filter=${filter}`);
